module.exports = __webpack_public_path__ + "fonts/ralewayextrabold.ae8bbc9.ttf";